<template>
<div>
    <v-row class="pa-2" no-gutters>
        <v-col cols="12" class="px-2 pt-0 pb-0">
            <h3 class="pa-0">Neuigkeiten</h3>
        </v-col>
        <v-col cols="12" class="px-2 pb-2">
            <NewsItem :loading="isLoading" @click="clickNewsArticle" :item="newsItem" type="single"></NewsItem>
        </v-col>
    </v-row>
    <v-row v-if="hasMoreNews">
        <v-col cols="12">
            <v-btn @click="showMoreNews" tile depressed block color="primary" large class="px-8 btn-more-news">
                <v-icon class="mr-5">mdi-bell-ring</v-icon>
                Weitere News im Überblick
                <v-icon class="btn-right-icon">mdi-chevron-right</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</div>
</template>
<script>
import NewsItem from '../design/NewsItem';
import {firebase} from '../../main';

export default {
    data() {
        return {
            isLoading: true,
            hasMoreNews: true,
            newsItem: null
        }
    },
    methods: {
        showMoreNews() {
            this.$router.push("/news");
        },
        clickNewsArticle(item) {
            if(item.hasOwnProperty("url")) {
                window.open(item.url, "_blank");
            }
        }
    },
    mounted() {
        firebase.firestore().collection("news").orderBy("timestamp", "desc").limit(1).onSnapshot(docs => {
            docs.forEach(doc => {
                this.newsItem = doc.data();
            });
            this.isLoading = false;
        });
    },
    components: {
        NewsItem
    }
}
</script>
<style lang="scss">
.btn-more-news {
    .v-btn__content {
        justify-content: start;
    }
    .btn-right-icon{
        position: absolute;
        right: 0;
    }
}
</style>